module.exports = __webpack_public_path__ + "img/dark.f6d512ec.svg";